import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {KMDGameMode} from "../server/KMDGameMode";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {KeypadSound} from "@nolimitcity/slot-keypad/bin/core/view/KeypadSound";

export class KMDSound {
    public static LOADER_LOOP: string = "loaderLoop";
    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static MAIN_GAME_MUSIC_NO_PLAY: string = "background-music-noplay";
    public static FS_MUSIC: string = "background-music-freespins";
    public static COOL_FS_MUSIC: string = "background-music-cool-freespins";
    public static SFS_MUSIC: string = "background-music-superfreespins";
    public static FS_INTRO_LOOP: string = "fsIntroLoop";
    public static CFS_INTRO_LOOP: string = "fsCoolIntroLoop";
    public static SFS_INTRO_LOOP: string = "sfsIntroLoop";

    // Action Spins Sound
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";

    public static LOADER_CONTINUE_BUTTON: string = "loaderContinueButton";
    public static BEEFY_INTRO: string = "beefyIntro";
    public static GLORY_HOLE_NEW_BALL: string[] = ["gloryHoleNewBall", "gloryHoleNewBallLevel2", "gloryHoleNewBallLevel3"];
    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    public static BASEMENT_REEL_STOP: string = "basementReelStop";
    public static X_BET_ON: string = "xBetOn";
    public static X_BET_OFF: string = "xBetOff";
    public static X_WAYS_LAND: string = "xWaysLand";
    public static X_WAYS_GROW: string = "xWaysGrow";
    public static X_WAYS_REVEAL: string = "xWaysReveal";
    public static X_NUDGE_LAND: string = "xNudgeLand";
    public static X_NUDGE_NUDGE_FAST: string = "xNudgeFast";
    public static X_NUDGE_NUDGE: string[] = ["xNudgeNudge1", "xNudgeNudge2", "xNudgeNudge3"];
    public static SYM_EXPLODE_1: string = "symExplode1";
    public static SYM_EXPLODE_2: string = "symExplode2";
    public static BIG_WIN_LEVEL_CHANGE: string = "bigWinLevelChange";
    public static BIG_WIN_LEVEL: string[] = ["bigWinLevel1", "bigWinLevel2", "bigWinLevel3", "bigWinLevel4", "bigWinLevel5", "winCapBeefyHitting"];
    public static BIG_WIN_END: string = "bigWinEnd";
    public static AVALANCHE_SYMBOL_DROP_IN: string = "avalanceSymbolDropIn";
    public static DRIVE_BY_BARBIE: string[] = ["driveByBarbie", "driveByBarbie2", "driveByBarbie3", "driveByBarbie4"];
    public static DRIVE_BY_KEN: string[] = ["driveByKenneth1", "driveByKenneth2", "driveByKenneth3"];
    public static DRIVE_BY_BEEFY: string[] = ["driveByBeefy", "driveByBeefy2", "driveByBeefy3", "driveByBeefy4"];
    public static WIN_BLINK: string = "winBlink";
    public static WIN_SCRAMBLE: string = "winScramble";
    public static WIN_SET_SYMBOL_ON_FIRE: string = "winSetSymbolOnFire";
    public static FS_INTRO_IMPACT: string = "fsIntroImpact";
    public static BTN_START_FS: string = "continueButtonStartFS";
    public static BTN_OUTRO_FS: string = "continueButtonFromFStoMain";
    public static CFS_INTRO_IMPACT: string = "fsCoolImpact";
    public static BTN_START_CFS: string = "fsCoolContinueButton";
    public static BTN_OUTRO_CFS: string = "fsCoolContinueButtonBackToMainGame";
    public static SFS_INTRO_IMPACT: string = "sfsIntroImpact";
    public static BTN_START_SFS: string = "continueButtonStartSFS";
    public static BTN_OUTRO_SFS: string = "continueButtonFromSFSToMain";
    public static CFS_ELEVATOR: string = "fsCoolElevator";
    public static SCATTER_LAND: string[] = ["scatter1", "scatter2", "scatter3", "scatter4"];
    public static SCATTER_ANTICIPATION: string = "scatterAnticipation";
    public static SCATTER_MISS: string = "scatter4Miss";
    public static SCATTER_ACTIVATION: string = "scatterActivation";
    public static BASEMENT_REEL_SPLIT_SYMBOL: string = "basementReelSplitSymbol";
    public static BASEMENT_REEL_MULTI_START: string = "basementReelMultiAddStart";
    public static BASEMENT_REEL_MULTI_COUNT_UP: string = "basementReelMultiCountUp";
    public static BASEMENT_REEL_MULTI_COUNT_UP_END: string = "basementReelMultiCountUpEnd";
    public static SYM_CHAIN_ADD: string = "symChainAdd";
    public static X_HOLE_LAND: string = "xHoleLand";
    public static X_HOLE_ACTIVATION: string = "xHoleActivation";
    public static X_HOLE_BLAST: string[] = ["xHolePoop1", "xHolePoop2", "xHolePoop3", "xHolePoop4", "xHolePoop5"];
    public static WIN_TINY: string = "winTiny";
    public static WIN_SMALL: string = "winSmall";
    public static WIN_MEDIUM: string = "winMedium";
    public static WIN_LARGE_COUNT_UP: string = "winLargeCountUp";
    public static WIN_LARGE_END: string = "winLargeEnd";
    public static CHAINED_UNLOCKED: string = "chainedUnlocked";
    public static X_HOLE_ACTIVATION_FAST: string = "xHoleActivationBonus";
    public static SFS_OUTRO_IMPACT: string = "sfsOutroImpact";
    public static WIN_CAP_COUNT_UP: string = "winCapCountUp";
    public static WIN_CAP_TOTAL_SUM_HIT: string = "winCapTotalSumHit";
    public static WIN_CAP_LOOP: string = "winCapLoop";
    public static WIN_CAP_BTN: string = "winCapContinueButtonBackToMain";
    public static WAYS_WON_PRESENTATION: string = "waysWonPresentation";
    public static SCATTER_FIRE: string = "scatterFire";
    public static X_HOLE_LAND_MISS: string = "xHoleLandMiss";
    public static X_HOLE_BLINKING: string = "xHoleBlinking";

    private _currentMusic: string = "";
    private _player: NolimitAudioPlayer;
    private _bgMusicFadeOutTween: gsap.core.Tween;

    constructor() {
        this._player = <NolimitAudioPlayer>KennethMustDie.sound;
        this._player.showLogs(true);
    }

    public switchMusic(mode: string, fadeOutConf?: IFadeTrackConf, fadeInConf?: IFadeTrackConf): void {
        const nextMusic: string = this.getMusicNameByMode(mode);

        if (nextMusic === this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade: NolimitHowl | undefined = this._player.fadeTrack(fadeOutConf);
                if (fade) {
                    this._bgMusicFadeOutTween = gsap.to(this, {
                        duration: fadeOutConf.duration / 1000, onComplete: () => {
                            this._player.stopTrack(fadeOutConf.name);
                        }
                    });
                } else {
                    this._player.stopTrack(fadeOutConf.name);
                }
            } else {
                this._player.stopTrack(this._currentMusic);
            }
        }

        this._player.playTrack(this.createConfig(nextMusic, (fadeInConf ? fadeInConf.from : 1), undefined));
        if (fadeInConf) {
            fadeInConf.name = nextMusic;
            this._player.fadeTrack(fadeInConf);
        }

        this._currentMusic = nextMusic;
    }

    public fadeMusic(fadeConfig: IFadeTrackConf): void {
        fadeConfig.name = fadeConfig.name || this._currentMusic;
        this._player.fadeTrack(fadeConfig);
    }

    // #225
    public killBgFadeOutTl(): void {
        if (this._bgMusicFadeOutTween) {
            this._bgMusicFadeOutTween.pause();
            this._bgMusicFadeOutTween.kill();
        }
    }

    public playLimitCapBtnSound(): void {
        this._player.playKeypadSound(KeypadSound.CLICK);
    }

    public playSound(name: string, volume?: number, repeat?: number): NolimitHowl | undefined {
        return this._player.playTrack(this.createConfig(name, volume, repeat));
    }

    public stopSound(name: string): void {
        this._player.stopTrack(name);
    }

    public tryStopScatterAnticipationSound(): void {
        const scatterAnticipationSound: NolimitHowl | undefined = this._player.fetchSoundPlayer(KMDSound.SCATTER_ANTICIPATION);

        if (scatterAnticipationSound && scatterAnticipationSound.isPlaying) {
            this.stopSound(KMDSound.SCATTER_ANTICIPATION);

            this.playSound(KMDSound.SCATTER_MISS);
        }
    }

    private getMusicNameByMode(mode: KMDGameMode): string {
        switch (mode) {
            case KMDGameMode.FREESPIN:
            case KMDGameMode.FREESPIN_AVALANCHE:
                return KMDSound.FS_MUSIC;
            case KMDGameMode.FREESPIN_COOL:
            case KMDGameMode.FREESPIN_COOL_AVALANCHE:
                return KMDSound.COOL_FS_MUSIC;
            case KMDGameMode.FREESPIN_SUPER:
            case KMDGameMode.FREESPIN_SUPER_AVALANCHE:
                return KMDSound.SFS_MUSIC;
            case "loaderLoop":
                return KMDSound.LOADER_LOOP;
            case "noPlay":
                return KMDSound.MAIN_GAME_MUSIC_NO_PLAY;
            case "fsIntro":
                return KMDSound.FS_INTRO_LOOP;
            case "cfsIntro":
                return KMDSound.CFS_INTRO_LOOP;
            case "sfsIntro":
                return KMDSound.SFS_INTRO_LOOP;
            default:
                return KMDSound.MAIN_GAME_MUSIC;
        }
    }

    private createConfig(name: string, volume?: number, repeat?: number): IPlayTrackConf {
        return {
            name: name,
            volume: volume,
            repeat: repeat
        };
    }
}